import React, { useState } from 'react';
import { Button, Card, Col, Stack } from 'react-bootstrap';
import IconButton from '../../ui/IconButton';
import { faCheck, faClose, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Input from '../../ui/Input';
import { deleteResourceCategory, patchResourceCategory } from '../../../services/httpClient';

interface CategoryCardState {
  category: any;
  getResourceCategories: any;
  getResources: any;
  setOrgToSave: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  setErrMsg: any;
}

const CategoryCard = ({
  category,
  getResourceCategories,
  getResources,
  setOrgToSave,
  setShowToast,
  setToastText,
  setToastBody,
  setErrMsg,
}: CategoryCardState) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [categoryName, setCategoryName] = useState<string>(category?.name);

  const onClickEdit = () => {
    setIsEditing(true);
  };

  const onClickEditFinal = async () => {
    const updatedCategory = {
      name: categoryName,
    };

    await patchResourceCategory(updatedCategory, category?.id)
      .then((res: any) => {
        setOrgToSave(false);
        setShowToast(true);
        setToastText("Category Updated");
        setToastBody(categoryName);
        setIsEditing(false);
        getResourceCategories();
        getResources();
      })
      .catch((err: any) => {
        setErrMsg(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelEdit = () => {
    setCategoryName(category?.name);
    setOrgToSave(false);
    setIsEditing(false);
    setErrMsg("");
  };

  const onUpdateName = (e: any) => {
    setCategoryName(e.target.value);
    setOrgToSave(true);
    setErrMsg("");
  };

  const onClickDelete = () => {
    setIsDeleting(true);
  };

  const onClickDeleteFinal = () => {
    deleteResourceCategory(category?.id)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Category Deleted");
        setToastBody(categoryName);
        setIsDeleting(false);
        getResourceCategories();
        getResources();
      })
      .catch((err: any) => {
        setIsDeleting(false);
        setErrMsg(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
    setErrMsg("");
  };

  const renderEdit = () => {
    return (
      <Stack direction="horizontal" gap={3}>
        <Col className="flex-grow-1">
          <Input label="Name" type="text" value={categoryName} onUpdate={(e: any) => onUpdateName(e)} hasFocus={true} />
        </Col>
        <Stack direction="horizontal" gap={3}>
          <IconButton onClickButton={onClickEditFinal} tooltipText={"Save"} icon={faCheck} />
          <div className="vr" />
          <IconButton onClickButton={onClickCancelEdit} tooltipText={"Cancel"} icon={faClose} />
        </Stack>
      </Stack>
    );
  };

  const renderDelete = () => {
    return (
      <Stack direction="horizontal" gap={3}>
        <Stack style={{ justifyContent: "center" }} gap={2}>
          <Card.Subtitle className="m-0">Delete {category?.name}?</Card.Subtitle>
        </Stack>
        <Button className="app-danger-color button text-nowrap" onClick={onClickDeleteFinal}>
          Confirm Delete
        </Button>
        <div className="vr" />
        <Button className="app-primary-color button" onClick={onClickCancelDelete}>
          Cancel
        </Button>
      </Stack>
    );
  };

  return (
    <Card key={category?.id} className="bg-light mb-2">
      <Card.Body>
        {isEditing ? (
          <>{renderEdit()}</>
        ) : isDeleting ? (
          <>{renderDelete()}</>
        ) : (
          <Stack direction="horizontal" gap={3}>
            <Stack className="align-self-center">
              <Card.Subtitle className="m-0">
                <small>{category?.name}</small>
              </Card.Subtitle>
            </Stack>
            <IconButton onClickButton={onClickEdit} tooltipText={"Edit"} icon={faEdit} />
            <div className="vr" />
            <IconButton onClickButton={onClickDelete} tooltipText={"Delete"} icon={faTrash} />
          </Stack>
        )}
      </Card.Body>
    </Card>
  );
};

export default CategoryCard;
